
  /**
   * docElement is a convenience wrapper to grab the root element of the document
   *
   * @access private
   * @returns {HTMLElement|SVGElement} The root element of the document
   */
  var docElement = document.documentElement;
  module.exports = docElement;




//////////////////
// WEBPACK FOOTER
// ./~/browsernizr/lib/docElement.js
// module id = 35
// module chunks = 0